import React from 'react';

// Filled side-profile car — matches the filled style of House.js. Used as the
// unit token in the parking-capacity pictograph (one car = one space). Sized via
// the `size` prop (defaults to 16 to match the other icons); colour via `fill`.
function Car(props) {
    const fill = props.fill;
    const className = props.className;
    const size = props.size || 16;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            {/* cabin */}
            <path
                d="M7.5 9 L9 6 Q9.4 5.4 10.2 5.4 L13.8 5.4 Q14.7 5.4 15.2 6.1 L17 9 Z"
                fill={fill}
            />
            {/* body */}
            <rect x="2.5" y="9" width="19" height="5" rx="2" fill={fill} />
            {/* wheels */}
            <circle cx="7.5" cy="15" r="2.3" fill={fill} />
            <circle cx="16.5" cy="15" r="2.3" fill={fill} />
        </svg>
    );
}

export default Car;
